import Icon from 'veui/components/Icon'
import { IconDataMarket } from 'dls-icons-vue'

Icon.register('data-market', IconDataMarket)
